// src/services/analytics.ts
import api from '../lib/api';

export interface DashboardStats {
  users: {
    total: number;
    new: number;
    active: number;
    inactive: number;
  };
  connections: {
    total: number;
    thisMonth: number;
    pending: number;
    accepted: number;
  };
  messages: {
    total: number;
    thisMonth: number;
    averagePerUser: number;
  };
  marketplace: {
    total: number;
    active: number;
    pending: number;
    thisMonth: number;
  };
}

export interface UserGrowthData {
  month: string;
  users: number;
  experts: number;
  members: number;
}

export interface UserDistribution {
  name: string;
  value: number;
  color?: string;
}

export interface WeeklyActivity {
  name: string;
  logins: number;
  connections: number;
  messages: number;
}

export interface IndustryEngagement {
  industry: string;
  views: number;
  interactions: number;
}

export const getDashboardStats = async (): Promise<DashboardStats> => {
  const response = await api.get('/api/analytics/dashboard-stats');
  return response.data;
};

export const getUserGrowth = async (): Promise<UserGrowthData[]> => {
  const response = await api.get('/api/analytics/user-growth');
  return response.data;
};

export const getUserDistribution = async (): Promise<UserDistribution[]> => {
  const response = await api.get('/api/analytics/user-distribution');
  return response.data;
};

export const getWeeklyActivity = async (): Promise<WeeklyActivity[]> => {
  const response = await api.get('/api/analytics/weekly-activity');
  return response.data;
};

export const getIndustryEngagement = async (): Promise<IndustryEngagement[]> => {
  const response = await api.get('/api/analytics/industry-engagement');
  return response.data;
};
